import en from "./en.json";
import it from "./it.json";

const home = { en, it };

export default home;
